import React, { useState } from 'react';
import {
  Card,
  Button,
  Input,
  notification,
  Typography,
  Form
} from 'antd';
import {
  UserOutlined,
  ArrowLeftOutlined
} from '@ant-design/icons';
import { useNavigate, useLocation } from 'react-router-dom';
import { httpService } from '../../services/httpService';
import { useTheme } from '../../theme/ThemeProvider';
import './styles.css';

const { Title, Text } = Typography;

const UserRegistration: React.FC = () => {
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const phoneNumber = location.state?.phoneNumber;
  const [form] = Form.useForm();
  const { theme } = useTheme();

  if (!phoneNumber || phoneNumber.length < 10) {
    notification.error({ message: 'شماره تلفن نامعتبر است' });
    navigate('/');
    return null;
  }



  const handleSubmit = async (values: { username: string; otp: string }) => {
    const { username } = values;
    
    // Validate username
    if (!username || username.trim().length < 3) {
      notification.error({ message: 'لطفا نام کاربری معتبر وارد کنید (حداقل ۳ حرف)' });
      return;
    }
    
    const finalUsername = username.trim();

    const finalOtp = values.otp;
    
    if (!finalOtp || finalOtp.length !== 6 || !/^\d{6}$/.test(finalOtp)) {
      notification.error({ message: 'لطفا کد تایید 6 رقمی معتبر وارد کنید' });
      return;
    }

    setIsLoading(true);
    try {
                           await httpService.registerAndLogin({
         username: finalUsername,
         mobileNumber: phoneNumber,
         password: finalOtp, // Use OTP as password for new user registration
         remember: false,
         isOTP: true
       });
      
      notification.success({ message: 'ثبت نام و ورود موفقیت‌آمیز بود' });
      navigate('/home');
    } catch (error: any) {
      const errorMessage = error.response?.data?.message || 'خطا در ثبت نام کاربر';
      notification.error({ message: errorMessage });
      console.error('User registration error:', error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleBackToLogin = () => {
    navigate('/');
  };

  return (
    <div className="user-registration-container">
      <div className="user-registration-content">
        <Card className="card-themed">
          <div style={{ textAlign: 'center', marginBottom: 32 }}>
            <Title level={2} style={{ marginBottom: 8, color: theme.text.primary }}>
              تکمیل اطلاعات کاربری
            </Title>
            <Text type="secondary" style={{ fontSize: 16, color: theme.text.secondary }}>
              لطفا اطلاعات خود را تکمیل کنید
            </Text>
            <br />
            <Text type="secondary" style={{ fontSize: 14, color: theme.text.secondary }}>
              شماره تلفن: {phoneNumber}
            </Text>
          </div>

          <Form 
            form={form}
            layout="vertical" 
            onFinish={handleSubmit}
            size="large"
          >
                         <Form.Item 
               label="نام کاربری"
               name="username"
               rules={[
                 { required: true, message: 'لطفا نام کاربری را وارد کنید' },
                 { min: 3, message: 'نام کاربری باید حداقل ۳ حرف باشد' }
               ]}
             >
               <Input
                 placeholder="مثال: محمد فارسی"
                 prefix={<UserOutlined style={{ color: theme.primary }} />}
                 maxLength={100}
               />
             </Form.Item>

                         <Form.Item 
               label="کد تایید"
               name="otp"
               rules={[
                 { required: true, message: 'لطفا کد تایید را وارد کنید' },
                 { pattern: /^\d{6}$/, message: 'کد تایید باید ۶ رقم باشد' }
               ]}
             >
              <Input
                placeholder="کد 6 رقمی"
                maxLength={6}
                style={{ 
                  textAlign: 'center', 
                  fontSize: 18, 
                  letterSpacing: 8,
                  direction: 'ltr'
                }}
              />
            </Form.Item>

            <Form.Item style={{ marginBottom: 16 }}>
              <Button
                type="primary"
                size="large"
                block
                loading={isLoading}
                htmlType="submit"
                icon={<UserOutlined />}
              >
                تکمیل ثبت نام
              </Button>
            </Form.Item>

            <Form.Item style={{ marginBottom: 0 }}>
              <Button
                type="text"
                block
                icon={<ArrowLeftOutlined />}
                onClick={handleBackToLogin}
                style={{ color: theme.text.secondary }}
              >
                بازگشت به صفحه ورود
              </Button>
            </Form.Item>
          </Form>
        </Card>
      </div>
    </div>
  );
};

export default UserRegistration;
